import { Dispatch, SetStateAction } from "react";

import { useMediaQuery, useTheme } from "@material-ui/core";
import { CategoryType } from "../types/types";
import MobileShowcaseNavbar from "./mobile/MobileShowcaseNavbar";
import WebShowcaseNavbar from "./web/WebShowcaseNavbar";

interface ShowcaseNavbarProps {
  category: string;
  setCategory: Dispatch<SetStateAction<CategoryType>>;
}

function ShowcaseNavbar({ category, setCategory }: ShowcaseNavbarProps) {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down("xs"));

  return mobileView ? (
    <MobileShowcaseNavbar category={category} setCategory={setCategory} />
  ) : (
    <WebShowcaseNavbar category={category} setCategory={setCategory} />
  );
}

export default ShowcaseNavbar;
